import { MenuTopItemProps } from "../types";
import CtaContent from "components/CtaContent";
import MenuNav from "./MenuNav";
import React from "react";
import cn from "classnames";
import dictionary from "configs/dictionary";

const MenuTopItem = ({
  data,
  currentLevel = 0,
  nextMenuMobile,
  className,
}: MenuTopItemProps) => {
  // TODO: create a type on dictionary
  const ComponentLink =
    dictionary.ContentfulCtaReferenceV2 as React.ElementType;
  const { content, pageReference, customClass } = data;

  const itemLinkClass = cn("menuItem__link", customClass);

  const classForNavMenu = cn(className);

  return (
    <>
      <ComponentLink
        {...pageReference}
        className={itemLinkClass}
        onClick={nextMenuMobile}
      >
        <CtaContent {...pageReference.content[0]} />
      </ComponentLink>
      {content &&
        content.length > 0 &&
        content.map((el) => {
          return (
            <MenuNav
              menu={el}
              currentLevel={currentLevel + 1}
              key={el.id}
              classFromParent={classForNavMenu}
            />
          );
        })}
    </>
  );
};

export default MenuTopItem;
